import React from 'react';
import styled from 'styled-components';

const TabContainer = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.colors.whiteColor};
  border: 1px solid ${(props) => props.theme.colors.subColor};
  border-radius: 15px;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 10px 5px;
    border-radius: 5px;
  }
`;

const StyledTabButton = styled.button<{ $active: boolean }>`
  flex: 1;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: #fff;
  position: relative;

  &:not(:last-child) {
    border-right: 1px solid ${(props) => props.theme.colors.subColor};
  }
`;

const Text = styled.span<{ $active: boolean }>`
  font-weight: ${(props) => (props.$active ? 700 : 400)};
  font-size: 18px;
  border-bottom: 3px solid
    ${(props) => (props.$active ? props.theme.colors.mainColor : 'transparent')};
  padding: 5px 0;

  @media (max-width: 768px) {
    padding: 1px 0;
    font-size: 12px;
    border-bottom: 2px solid
      ${(props) =>
        props.$active ? props.theme.colors.mainColor : 'transparent'};
  }
`;

interface TabButtonProps {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

const TabButton: React.FC<TabButtonProps> = ({ active, onClick, children }) => {
  return (
    <StyledTabButton $active={active} onClick={onClick}>
      <Text $active={active}>{children}</Text>
    </StyledTabButton>
  );
};

const TabContent = styled.div`
  padding-top: 20px;
`;

interface TabData {
  title: string;
  content: React.ReactNode;
}

interface TabComponentProps {
  tabs: TabData[];
  activeTab: number;
  onTabChange: (index: number) => void;
}

const TabComponent: React.FC<TabComponentProps> = ({
  tabs,
  activeTab,
  onTabChange,
}) => {
  return (
    <div>
      <TabContainer>
        {tabs.map((tab, index) => (
          <TabButton
            key={index}
            active={activeTab === index}
            onClick={() => onTabChange(index)}
          >
            {tab.title}
          </TabButton>
        ))}
      </TabContainer>
      <TabContent>{tabs[activeTab]?.content}</TabContent>
    </div>
  );
};

export default TabComponent;
